// extracted by mini-css-extract-plugin
module.exports = {"mainImage":"sign-in-form_mainImage__ZlfR8"};